import { Controller } from "@hotwired/stimulus"

// This controller handles auto-dismissing flash messages after a set timeout
export default class extends Controller {
  static values = {
    dismissAfter: { type: Number, default: 3000 } // Default 3 seconds (3000ms)
  }

  connect() {
    // Start the timer when the controller connects to the DOM
    this.dismissTimeout = setTimeout(() => {
      this.dismiss()
    }, this.dismissAfterValue)
  }

  disconnect() {
    // Clear the timeout if the element is removed from the DOM before timeout completes
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout)
    }
  }

  dismiss() {
    // Use Bootstrap's dismiss capability if available
    if (window.bootstrap && window.bootstrap.Alert) {
      const bsAlert = new window.bootstrap.Alert(this.element)
      bsAlert.close()
    } else {
      // Fallback: just remove the element from the DOM
      this.element.remove()
    }
  }
}
